<template>
  <article class="layout-section -align-side -reverse">
    <figure class="layout-section__figure -reverse" :style="{ backgroundImage }" />

    <section class="layout-section__content">
      <h2 class="layout-section__title">{{ wp.services.title }}</h2>
      <p>
        {{ wp.services.text }}
      </p>

      <RouterLink :to="{ name: 'resources-research' }" class="button layout-section__cta">
        Explorez ces services
        <SvgIcon id="action-arrow" />
      </RouterLink>
    </section>
  </article>
</template>

<script>
export default {
  name: 'ResourcesMore',
  inject: ['wp'],
  computed: {
    backgroundImage() {
      return `url(${this.wp.services.image})`
    }
  }
}
</script>
